import pdfUrl_zh from "@/assets/file/howToUse_zh.pdf";
import pdfUrl_en from "@/assets/file/howToUse_en.pdf";
import { useMemo } from "react";
const HowToShare = () => {
	const lang = useMemo(() => {
		return localStorage.getItem("lang") || "en-US"
	}, []);
	return <div className="container">
		<iframe title="helloWord" src={lang === "zh-CN" ? pdfUrl_zh : pdfUrl_en} width="100%" height="100%" style={{ height: "calc(100vh - 90px)" }} />
	</div>
}
export default HowToShare;